import _ from 'underscore';

export const TextAd = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Text Ad',
    },
    DisplayUrl: {
      'bulk-upload-header': 'Display Url',
    },
    DestinationUrl: {
      'bulk-upload-header': 'Destination Url',
    },
    FinalUrls: {
      'bulk-upload-header': 'Final Url',
      'bulk-upload-mapper': function (value) {
        return value.join('; ');
      },
    },
    MobileFinalUrls: {
      'bulk-upload-header': 'Mobile Final Url',
      'bulk-upload-mapper': function (value) {
        return value.join('; ');
      },
    },
    TrackingUrlTemplate: {
      'bulk-upload-header': 'Tracking Template',
    },
    UrlCustomParameters: {
      'bulk-upload-header': 'Custom Parameter',
      'bulk-upload-mapper': function (value) {
        return _.map(value, p => `{_${p.Key}}=${p.Value}`).join('; ');
      },
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
    AdGroupName: {
      'bulk-upload-header': 'Ad Group',
    },
    DevicePreference: {
      'bulk-upload-header': 'Device Preference',
    },
    NativePreference: {
      'bulk-upload-header': 'Ad Format Preference',
      'bulk-upload-mapper': function (value) {
        const mapping = {
          None: 'All',
          NativePreference: 'Native',
        };

        return mapping[value];
      },
    },
  },
};
